import LinearColors from '../../components/LinearColors';
import {Colors} from '../../configs';
import React, {memo} from 'react';
import {
  View,
  Image,
  StyleSheet,
  TouchableOpacity,
  ViewStyle,
  Switch,
} from 'react-native';
import Theme from '../../style/Theme';
import Text from '../../components/Text';
import {SOURCE_ICON} from '../../images';
import Line from '../../components/Layout/Line';

interface AccountItemProps {
  icon?: any;
  iconRight?: any;
  iconStyle?: ViewStyle;
  linearColorDisabled?: boolean;
  name?: string;
  subtitle?: string;
  isToggle?: boolean;
  style?: ViewStyle;
  nameStyle?: ViewStyle;
  onPress?: () => void;
  switchValue?: boolean;
  onValueChange?: () => void;
  lineBottom?: boolean;
  hideArrowAndToggle?: boolean;
  disabled?: boolean;
}

const getIcon = (icon: any, iconStyle: ViewStyle) => {
  return <Image source={icon} style={[styles.icon, iconStyle]} resizeMode="contain" />;
};

const renderIcon = (
  icon: any,
  iconStyle: ViewStyle,
  linearColorDisabled: boolean,
) => {
  return linearColorDisabled !== true ? (
    <LinearColors
      colors={[Colors.TealBlue, Colors.TurquoiseBlue]}
      style={styles.contentIcon}>
      {getIcon(icon, iconStyle)}
    </LinearColors>
  ) : (
    getIcon(icon, iconStyle)
  );
};

const AccountItem = memo(
  ({
    icon,
    iconRight,
    iconStyle,
    linearColorDisabled = false,
    name,
    subtitle,
    isToggle,
    style,
    nameStyle,
    onPress,
    switchValue,
    lineBottom,
    onValueChange,
    hideArrowAndToggle = false,
    disabled
  }: AccountItemProps) => {
    return (
      <View>
        <TouchableOpacity style={style} onPress={onPress} activeOpacity={0.54}>
          <View style={[Theme.flexRow, { flex: 1 }]}>
            {icon && renderIcon(icon, iconStyle, linearColorDisabled)}
            <View style={{ flex: 1, marginRight: 16 }}>
              <Text size={15} marginLeft={icon ? 16 : 0} style={nameStyle}>
                {name}
              </Text>
              {subtitle && (
                <Text size={13} marginLeft={icon ? 16 : 0} marginTop={4} style={{ color: Colors.GrayBlue }}>
                  {subtitle}
                </Text>
              )}
            </View>
            {iconRight && renderIcon(iconRight, iconStyle, linearColorDisabled)}
          </View>
          {!hideArrowAndToggle && <View pointerEvents="none">
            {isToggle === true ? (
              <Switch disabled={disabled} value={switchValue} onValueChange={onValueChange} />
            ) : (
              <Image source={SOURCE_ICON.arrowRight} style={{width: 16, height: 16}} />
            )}
          </View>}
        </TouchableOpacity>
        {lineBottom ? <Line /> : null}
      </View>
    );
  },
);

export default AccountItem;

const styles = StyleSheet.create({
  icon: {
    tintColor: Colors.White,
    alignSelf: 'center',
    maxWidth: 40,
    maxHeight: 40,
    width: '50%',
    height: '50%',
  },
  contentIcon: {
    width: 40,
    height: 40,
    backgroundColor: Colors.DodgerBlue,
    borderRadius: 8,
    justifyContent: 'center',
  },
});
